export default {
      id: "lax-drawer-two-open-usage",
      viewBox: "0 0 997 852",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#lax-drawer-two-open",
      toString: function () {
        return this.url;
      }
    }